const config = {
    baseUrl: process.env.NODE_ENV === 'development' ? "https://jobs-api.tsingmicro.com" : "https://jobs-api.tsingmicro.com"  //测试环境
}
export {
    config
}
